import ProfileIndex from '@components/ProfileIndex';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import type { GetStaticProps, NextPage } from 'next';

const ProfileIndexView: NextPage = () => <ProfileIndex />;

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('profileIndex');

export default ProfileIndexView;
